import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/activity_table'
import ActivityService from '../../network/services/activity'
import { serialize } from '../../network/request'
import ActivityTable from './ActivityTable'

const ActivityPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Activity
    </Button>
  )

  return (
    <PageHeader title="All Activities" extra={[primaryAction]}>
      <Card>
        <ActivityTableWrapper />
      </Card>
    </PageHeader>
  )
}

const ActivityTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(ActivityService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  console.log(response)

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = ActivityService.toPaginate(response)

  return (
    <>
      <ActivityTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <ActivityTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default ActivityPage
